<div class="register-complete-container">
    <div *ngIf="percentage >= 100">
        <mat-icon class="">check</mat-icon>
        <p>Sua solicitação foi gerada com sucesso.
        Verifique seu e-mail, onde notificaremos o status da sua solicitação.
        </p>
    </div>
    <app-progress-bar  [percentage]="percentage" *ngIf="percentage < 100" ></app-progress-bar>
</div>
